import { render } from "./projectList.vue?vue&type=template&id=74b972d6&scoped=true"
import script from "./projectList.js?vue&type=script&lang=js"
export * from "./projectList.js?vue&type=script&lang=js"

import "./projectList.vue?vue&type=style&index=0&id=74b972d6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74b972d6"]])

export default __exports__